module.exports = __webpack_public_path__ + "img/linkedin.5d8737dc.svg";